import { DefaultNodeData } from "@zapier/canvas-state";
import { Node, NodeProps } from "@xyflow/react";
import { ASSET_APP_IDS } from "@zapier/canvas-constants";

import { TableNode } from "../TableNode";
import { InterfaceNode } from "../InterfaceNode";
import { ChatbotNode } from "../ChatbotNode/ChatbotNode";
import { DefaultNodeContentInner } from "../DefaultNode/DefaultNodeContent";

import { AssetNodeSkeleton } from "./AssetNodeSkeleton";

export interface AssetNodeProps {
  className: string;
}

export function AssetNodeDeterminer(
  props: NodeProps<Node<DefaultNodeData>> & AssetNodeProps,
) {
  const appId = props.data.services?.[0]?.currentImplementation.id ?? "";

  const isTableApp = appId.includes(ASSET_APP_IDS.TABLES);
  const isInterfacesApp = appId.includes(ASSET_APP_IDS.INTERFACES);
  const isChatbotsApp = appId.includes(ASSET_APP_IDS.CHATBOTS);

  if (isTableApp) {
    return <TableNode {...props} />;
  }

  if (isInterfacesApp) {
    return <InterfaceNode {...props} />;
  }

  if (isChatbotsApp) {
    return <ChatbotNode {...props} />;
  }

  if (appId) {
    return <AssetNodeSkeleton {...props} placeholder="What should we build?" />;
  }

  return <DefaultNodeContentInner {...props} />;
}
